import React from 'react'
import { Loader } from 'components/UIElements'
import { browserHistory } from 'utils/navigation'
import { STUDY_VERSION_ID_URL_PLACEHOLDER } from 'utils/constants'

export default props => {
  const { hasInsights, loading, header, message, className } = props
  const redirect = className === 'ptp-compliance' ? 'participants' : 'instruments'
  return (
    <div className={`d3-chart-container ${className}`}>
      <div className='flexed column chart-section empty'>
        <div className='chart-header flexed'>
          <h4>{header}</h4>
        </div>
        {loading ? (
          <div style={{ height: 400 }}>
            <Loader inContainer />
          </div>
        ) : (
          <h5>{message}</h5>
        )}
      </div>
      {!hasInsights && <RedirectButton {...props} redirect={redirect} />}
    </div>
  )
}
export const RedirectButton = ({ studyID, buttonText, redirect, studyVersionID }) => {
  const safeRedirect = redirect ?? 'compliance'
  const safeVersionID = studyVersionID ?? STUDY_VERSION_ID_URL_PLACEHOLDER
  return (
    <div
      onClick={() => browserHistory.push(`/studies/${studyID}/${safeVersionID}/${safeRedirect}`)}
      className='bottom-section clickable'>
      {buttonText}
    </div>
  )
}
